import React from "react";
import Chart from 'chart.js';
import {
  Card, CardHeader,
  CardBody, CardFooter, Label
} from "reactstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from "classnames";
import { GetLowestConterList } from "../../api/CounterApi";


class TopCounter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      data: [],
      chartData: null,

      startDate: this.props.DataFromDashboard.selectedStartDate,
      endDate: this.props.DataFromDashboard.selectedEndDate,
      operator: this.props.DataFromDashboard.paramOperator,
      productType: this.props.DataFromDashboard.paramType,
      companyId: this.props.DataFromDashboard.companyId,
      userId: this.props.DataFromDashboard.userId,
      roleId: this.props.DataFromDashboard.roleId
    }

    this.canvasRef = React.createRef();

  }

  bindData() {

    const { data } = this.state;

    let displayNameArr = [];
    let sellPriceArr = [];

    data.forEach((item) => {
      displayNameArr.push(item.displayName);
      sellPriceArr.push(item.sellPrice);
    });

    let chartData = {
      ...this.state.chartData,
      labels: displayNameArr,
      datasets: [
        {
          label: 'Lowest 10 Counter',
          backgroundColor: "rgba(0,166,255,1)",
          borderColor: "rgba(0,201,255,1)",
          pointBackgroundColor: "#ffffff",
          pointHoverBackgroundColor: "rgb(0,123,255)",
          borderWidth: 1.5,
          pointRadius: 0,
          pointHoverRadius: 5,
          data: sellPriceArr,
        },
      ],
    };
    this.setState({ chartData });

  }


  async componentDidMount() {
    const resdata = await GetLowestConterList(this.state);
    this.setState({ data: Array.isArray(resdata) ? resdata : [] });
    this.bindData();

    if (this.state.data.length !== 0) {
      const chartOptions = {
        ...{
          responsive: true,
          legend: {
            position: "top"
          },
          title: {
            display: false,
            text: 'Trans'
          },
          hover: {
            mode: "nearest",
            intersect: false
          },
          tooltips: {
            custom: function (tooltip) {
              if (!tooltip) return;
              tooltip.displayColors = false;
            },
            callbacks: {
              label: function (tooltipItem, data) {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${datasetLabel}: ${value.toLocaleString('en')}`;
              }
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                autoSkip: false,
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                precision: 0,
                callback: function (value, index, values) {
                  return value.toLocaleString('en'); // Format y-axis tick labels with comma separator
                }
              }
            }]
          }
        },
      };

      const BlogUsersOverview = new Chart(this.canvasRef.current, {
        type: "bar",
        data: this.state.chartData,
        options: chartOptions
      });

      BlogUsersOverview.render();
    }

  }

  updateState(prop, value) {
    this.setState({ [prop]: value });
  }

  render() {
    return (
      <Card small className="h-200">
        <CardHeader className="border-bottom">
          <h6 className="m-0">Lowest 10 Counter</h6>
        </CardHeader>
        <CardBody className="d-flex pt-0">
          {this.state.data.length === 0 ?
            (
              <div className="m-auto text-muted" style={{ fontSize: '1.2rem', height: '200px', padding: '20px', margin: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                No Data
              </div>
            ) : (
              <canvas
                height="200"
                ref={this.canvasRef}
                style={{ maxWidth: "100% !important" }}
              />
            )
          }
        </CardBody>
        <CardFooter className="border-top">
        </CardFooter>
      </Card>
    );
  }
}

export default TopCounter;